import Icon from '../components/Icon.vue'

Icon.register({
  smile: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM328 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM362.8 346.2c13.5-16.3-11.2-36.7-24.6-20.5-22.4 26.8-55.2 42.2-90.2 42.2s-67.8-15.3-90.2-42.2c-13.6-16.2-38.2 4.2-24.6 20.5 28.5 34.2 70.3 53.8 114.8 53.8s86.3-19.6 114.8-53.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smile.js
// module id = 1905
// module chunks = 0